import { Navigate, useNavigate } from 'react-router-dom';
import { LpFooter, LpShell } from '@/shared/components/LpShell';
import { useTenant } from '@/modules/tenant/presentation/hooks/use-tenant';
import { AuthModal } from '@/modules/auth/presentation/components/AuthModal';
import { HeaderAccount } from '@/modules/auth/presentation/components/HeaderAccount';
import { useMySubmission } from '@/modules/submissions/presentation/hooks/use-submissions';
import { EnsaioRunner } from '../components/EnsaioRunner';
import { useFinishEnsaio } from '../hooks/use-finish-ensaio';

/** Para onde o ensaio leva depois do envio: o diagnóstico, no painel. */
export const ENSAIO_RESULT_PATH = '/minha-conta?aba=ensaio&sub=diagnostico';

/**
 * O ensaio de quem chega pela LP, antes da prova. Ao finalizar: cadastro (ou
 * login), envio e o diagnóstico no painel. Quem já enviou o ensaio desta
 * edição não refaz: vai direto ver o que fez.
 */
export function SimuladoPage() {
  const { exam, theme } = useTenant();
  const navigate = useNavigate();
  const myEnsaio = useMySubmission('ensaio');
  const { finish, authModalProps, isSubmitting, isError } = useFinishEnsaio(
    () => navigate(ENSAIO_RESULT_PATH),
  );

  if (myEnsaio.data) return <Navigate to={ENSAIO_RESULT_PATH} replace />;

  return (
    <LpShell theme={theme} headerRight={<HeaderAccount />}>
      <title>{`Ensaio ${exam.shortName}`}</title>

      <section className="fold">
        <div className="wrap">
          <h1 className="page-title">Ensaio {exam.shortName}</h1>
          <p className="page-lead">
            Escolha a alternativa e confirme. Suas respostas ficam salvas neste
            navegador, então você pode parar e voltar depois.
          </p>

          <div className="page-body">
            <EnsaioRunner
              onFinish={finish}
              isSubmitting={isSubmitting}
              submitError={isError}
            />
          </div>
        </div>
      </section>

      <LpFooter />
      <AuthModal {...authModalProps} />
    </LpShell>
  );
}
